
<template>
  <header class="main-header shadow-sm bg-white d-flex align-items-center justify-content-between px-4">
    
    <!-- سمت راست: لوگو -->
    <div class="d-flex align-items-center">
      <div class="dropdown">
        <button
          class="btn btn-light btn-sm lang-btn dropdown-toggle d-flex align-items-center gap-2"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="bi bi-translate"></i>
          {{ lang === "fa" ? "فارسی" : "English" }}
        </button>

        <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
          <li>
            <button
              class="dropdown-item d-flex align-items-center justify-content-between"
              @click="setLang('fa')"
            >
              <span>فارسی</span>
              <i v-if="lang === 'fa'" class="bi bi-check2"></i>
            </button>
          </li>
          <li>
            <button
              class="dropdown-item d-flex align-items-center justify-content-between"
              @click="setLang('en')"
            >
              <span>English</span>
              <i v-if="lang === 'en'" class="bi bi-check2"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- سمت چپ: آیکون‌ها و پروفایل -->
    <div class="d-flex align-items-center gap-3 header-actions">
      <i class="bi bi-bell text-secondary fs-5"></i>
      <i class="bi bi-chat-dots text-secondary fs-5"></i>

      <!-- پروفایل دراپ‌داون -->
      <div class="dropdown">
        <div class="cursor-pointer" data-bs-toggle="dropdown" aria-expanded="false">
          <div class="user-icon d-flex align-items-center justify-content-center">
            <i class="bi bi-person-fill"></i>
          </div>
        </div>

        <ul class="dropdown-menu dropdown-menu-end p-3 shadow-sm rounded-4 border-0">
          <li class="px-2 pb-2">
            <div class="fw-bold">{{ user.first_name + user.last_name }}</div>
            <div class="text-muted small">{{ user.mobile }}</div>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li>
            <button class="dropdown-item text-danger fw-semibold d-flex align-items-center" @click="logout">
              <i class="bi bi-box-arrow-right me-2"></i> {{ currentLang.logout }} 
            </button>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>



<script setup>
import { ref, onMounted,computed } from "vue";
import { useRouter } from "vue-router";
import { lang, setLang } from "@/plugins/lang";
import enLanguage from "@/locales/en/header";
import faLanguage from "@/locales/fa/header";

const translations = {
  en: enLanguage,
  fa: faLanguage,
};

const currentLang = computed(() => translations[lang.value]);


const router = useRouter();
const user = ref({ first_name: "", last_name: "", mobile: "", avatar: "" , kind: "" });

onMounted(() => {
  const info = JSON.parse(localStorage.getItem("user_info")) || {};
  user.value = {
    first_name: info.first_name || "کاربر",
    last_name: info.last_name || "",
    mobile: info.mobile || "0000000000",
    avatar: info.avatar || "",
    kind: info.kind || ""

  };
});

const logout = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("user_info");
  router.push("/");
};
</script>




<style scoped>
.main-header {
  min-height: 70px;
  background: #fff;
  padding: 0 25px;
  border-radius: 18px;
  margin: 24px;
  box-shadow: 0 4px 22px rgba(80, 80, 120, 0.10);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* --- profile avatar --- */
.profile-wrapper {
  position: relative;
  cursor: pointer;
}

.avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
  transition: 0.2s;
}
.avatar:hover {
  transform: scale(1.05);
}

/* --- dropdown menu --- */
.dropdown-menu-box {
  position: absolute;
  right: 0;
  top: 65px;
  width: 190px;
  background: white;
  border-radius: 14px;
  padding: 15px;
  box-shadow: 0 6px 20px rgba(60, 60, 80, 0.15);
  animation: fadeIn 0.2s ease;
  z-index: 999;
}

.user-info {
  margin-bottom: 10px;
  line-height: 1.4;
}

.user-info strong {
  display: block;
  font-size: 16px;
}

.user-info small {
  color: #555;
  font-size: 13px;
}

.dropdown-divider {
  height: 1px;
  background: #e5e5e5;
  margin: 10px 0;
}

/* logout button */
.logout-btn {
  width: 100%;
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}
.logout-btn:hover {
  background: #dc2626;
}

.user-icon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 2px solid #dee2e6;
  background: #f8f9fa;
  font-size: 22px;
  color: #6c757d;
  cursor: pointer;
  flex-shrink: 0;
}

.lang-btn {
  border-radius: 50px;
  min-width: 42px;
  font-weight: bold;
  transition: background 0.2s;
  white-space: nowrap;
}
.lang-btn:hover {
  background: #e9ecef;
}

.header-actions {
  flex-shrink: 0;
}

/* animation */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* =========================
   Responsive
========================= */

@media (max-width: 991.98px) {
  .main-header {
    margin: 16px;
    padding: 0 18px;
    border-radius: 16px;
  }

  .user-icon {
    width: 42px;
    height: 42px;
    font-size: 20px;
  }
}

@media (max-width: 767.98px) {
  .main-header {
    margin: 12px;
    padding: 12px 14px;
    min-height: auto;
  }

  .lang-btn {
    font-size: 13px;
    padding: 6px 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .header-actions {
    gap: 12px !important;
  }

  .header-actions i.fs-5 {
    font-size: 18px !important;
  }
}

@media (max-width: 575.98px) {
  .main-header {
    margin: 10px;
    padding: 10px 12px;
    gap: 10px;
  }

  .lang-btn {
    font-size: 12px;
    padding: 5px 9px;
  }

  .header-actions {
    gap: 10px !important;
  }

  .user-icon {
    width: 38px;
    height: 38px;
    font-size: 17px;
  }

  .dropdown-menu {
    min-width: 170px;
  }
}
</style>